import { theme } from '../../theme/theme';

// Shared series colours for the ecom/live sales report charts, so the same metric reads the same
// colour across every chart and the hex values aren't duplicated per component.
export const CHART_COLORS = {
  brandGreen: theme.palette.primary.main, // total sales / total orders
  blue: '#4A90D9', // call-center / orders (secondary count series)
  amber: '#F5A623', // pre-orders / average order value
  grey: '#9CA3AF', // moving average / reference lines
  violet: '#7C3AED', // web-store sales
  teal: '#0D9488', // mobile-app sales
};

// Modern, high-contrast categorical palette (distinct hues, not brand-bound) for donut charts.
// Sized to cover the full payment-method list without repeating, and ordered so
// similar hues (e.g. the greens/teals) never sit next to each other in a chart.
export const DONUT_PALETTE = [
  '#2563EB', // blue
  '#F59E0B', // amber
  '#DC2626', // red
  '#059669', // green
  '#7C3AED', // violet
  '#EA580C', // orange
  '#0891B2', // cyan
  '#DB2777', // magenta
  '#65A30D', // lime
  '#475569', // slate
  '#0D9488', // teal
  '#92400E', // brown
];
